import { useState } from "react";
import { Box, Button, Paper, Stack, Typography } from "@mui/material";

import { getAnalyticsConsent, setAnalyticsConsent } from "../helpers/analyticsConsent";

export default function AnalyticsConsentBanner() {
  const [consent, setConsent] = useState(getAnalyticsConsent);

  if (consent !== null) return null;

  const handleChoice = (granted) => {
    setAnalyticsConsent(granted);
    setConsent(granted);
  };

  return (
    <Paper
      elevation={4}
      sx={{
        position: "fixed",
        bottom: 16,
        left: 16,
        right: 16,
        zIndex: (theme) => theme.zIndex.snackbar,
        p: 2,
        maxWidth: 640,
        mx: "auto",
      }}
    >
      <Stack direction={{ xs: "column", sm: "row" }} spacing={2} alignItems="center">
        <Box sx={{ flex: 1 }}>
          <Typography variant="body2">
            PAD uses product analytics to understand how partners use the platform and improve it.
            We track how you use the platform, tied to your account. No voter file or partner data
            is included in analytics events.
          </Typography>
        </Box>
        <Stack direction="row" spacing={1}>
          <Button size="small" variant="text" onClick={() => handleChoice(false)}>
            Decline
          </Button>
          <Button size="small" variant="contained" onClick={() => handleChoice(true)}>
            Accept
          </Button>
        </Stack>
      </Stack>
    </Paper>
  );
}
